var map = {
	"./badges/12/badge_dzen_12.svg": [
		"+5/1",
		1546
	],
	"./badges/12/badge_success_12.svg": [
		"t+Mg",
		23742
	],
	"./badges/12/badge_verified_12.svg": [
		"dYj1",
		45191
	],
	"./badges/16/badge_dzen_16.svg": [
		"+nsr",
		20754
	],
	"./badges/16/badge_sa_author_16.svg": [
		"/lAX",
		31351
	],
	"./badges/16/badge_success_16.svg": [
		"lIJs",
		21150
	],
	"./badges/16/badge_verified_16.svg": [
		"0jdf",
		20327
	],
	"./badges/20/badge_dzen_20.svg": [
		"F6jE",
		94382
	],
	"./badges/20/badge_success_20.svg": [
		"K4sB",
		7328
	],
	"./badges/20/badge_verified_20.svg": [
		"MmwV",
		26803
	],
	"./badges/24/badge_dzen_24.svg": [
		"PFrH",
		69974
	],
	"./badges/24/badge_success_24.svg": [
		"76oB",
		39808
	],
	"./badges/24/badge_verified_24.svg": [
		"Q2mM",
		37795
	],
	"./glyphs/12/glyph_add_12.svg": [
		"B1XA",
		37190
	],
	"./glyphs/12/glyph_alert_circle_12.svg": [
		"Ig7v",
		79092
	],
	"./glyphs/12/glyph_arrow_down_diagonal_12.svg": [
		"JNUK",
		82277
	],
	"./glyphs/12/glyph_arrow_right_12.svg": [
		"w3Am",
		46109
	],
	"./glyphs/12/glyph_arrow_up_diagonal_12.svg": [
		"r3if",
		34998
	],
	"./glyphs/12/glyph_attach_12.svg": [
		"JLBG",
		60206
	],
	"./glyphs/12/glyph_back_12.svg": [
		"lLjz",
		29644
	],
	"./glyphs/12/glyph_block_12.svg": [
		"xsHU",
		66868
	],
	"./glyphs/12/glyph_bookmark_12.svg": [
		"NLA1",
		76335
	],
	"./glyphs/12/glyph_bookmark_off_12.svg": [
		"mrcE",
		82549
	],
	"./glyphs/12/glyph_camera_12.svg": [
		"u6Zs",
		54904
	],
	"./glyphs/12/glyph_clock_12.svg": [
		"5RAA",
		3427
	],
	"./glyphs/12/glyph_close_12.svg": [
		"uz79",
		94673
	],
	"./glyphs/12/glyph_comment_12.svg": [
		"l9HO",
		11376
	],
	"./glyphs/12/glyph_dislike_12.svg": [
		"G2IF",
		51550
	],
	"./glyphs/12/glyph_done_12.svg": [
		"kz0j",
		96207
	],
	"./glyphs/12/glyph_down_12.svg": [
		"mRSq",
		75075
	],
	"./glyphs/12/glyph_download_12.svg": [
		"JGRI",
		23151
	],
	"./glyphs/12/glyph_edit_12.svg": [
		"AtuB",
		72823
	],
	"./glyphs/12/glyph_explicit_12.svg": [
		"i4UG",
		88975
	],
	"./glyphs/12/glyph_explicit_filled_12.svg": [
		"ERoJ",
		28040
	],
	"./glyphs/12/glyph_favourite_12.svg": [
		"UVXU",
		61894
	],
	"./glyphs/12/glyph_favourite_filled_12.svg": [
		"UHyk",
		69819
	],
	"./glyphs/12/glyph_file_12.svg": [
		"uOdY",
		98057
	],
	"./glyphs/12/glyph_fire_12.svg": [
		"Y/p6",
		3591
	],
	"./glyphs/12/glyph_forward_12.svg": [
		"FiqB",
		37676
	],
	"./glyphs/12/glyph_gift_12.svg": [
		"IoSA",
		55653
	],
	"./glyphs/12/glyph_headphones_12.svg": [
		"lUT6",
		86760
	],
	"./glyphs/12/glyph_help_12.svg": [
		"sg11",
		35460
	],
	"./glyphs/12/glyph_help_circle_12.svg": [
		"ILfm",
		39621
	],
	"./glyphs/12/glyph_info_12.svg": [
		"Rqlz",
		1131
	],
	"./glyphs/12/glyph_info_circle_12.svg": [
		"0awq",
		82392
	],
	"./glyphs/12/glyph_klass_12.svg": [
		"dgP7",
		24245
	],
	"./glyphs/12/glyph_klass_groups_12.svg": [
		"pZwD",
		92746
	],
	"./glyphs/12/glyph_like_12.svg": [
		"y1Q8",
		6880
	],
	"./glyphs/12/glyph_link_external_12.svg": [
		"k+vm",
		9839
	],
	"./glyphs/12/glyph_list_12.svg": [
		"Vwme",
		45359
	],
	"./glyphs/12/glyph_location_12.svg": [
		"z7B9",
		86856
	],
	"./glyphs/12/glyph_lock_12.svg": [
		"RsOX",
		29292
	],
	"./glyphs/12/glyph_loudspeaker_12.svg": [
		"k4ha",
		53788
	],
	"./glyphs/12/glyph_maximize_12.svg": [
		"KNcB",
		38085
	],
	"./glyphs/12/glyph_message_12.svg": [
		"JIvh",
		11462
	],
	"./glyphs/12/glyph_message_opened_12.svg": [
		"XLAd",
		15886
	],
	"./glyphs/12/glyph_microphone_12.svg": [
		"aH14",
		63775
	],
	"./glyphs/12/glyph_mini_down_12.svg": [
		"3nM9",
		32201
	],
	"./glyphs/12/glyph_mini_up_12.svg": [
		"+xtM",
		58652
	],
	"./glyphs/12/glyph_minus_12.svg": [
		"IAX4",
		97373
	],
	"./glyphs/12/glyph_mobile_12.svg": [
		"DssF",
		32853
	],
	"./glyphs/12/glyph_mobile_online_12.svg": [
		"wz5S",
		98529
	],
	"./glyphs/12/glyph_more_horizon_12.svg": [
		"HqEv",
		88226
	],
	"./glyphs/12/glyph_more_vertical_12.svg": [
		"fjN1",
		21529
	],
	"./glyphs/12/glyph_movie_12.svg": [
		"W8vm",
		68117
	],
	"./glyphs/12/glyph_music_12.svg": [
		"fs3g",
		5846
	],
	"./glyphs/12/glyph_music_note_12.svg": [
		"xW6e",
		72111
	],
	"./glyphs/12/glyph_notifications_12.svg": [
		"hPqv",
		37085
	],
	"./glyphs/12/glyph_notifications_off_12.svg": [
		"5v47",
		90403
	],
	"./glyphs/12/glyph_ok_circle_12.svg": [
		"dY+v",
		59526
	],
	"./glyphs/12/glyph_ok_circle_filled_12.svg": [
		"uvDz",
		40475
	],
	"./glyphs/12/glyph_ok_live_12.svg": [
		"ngB7",
		5500
	],
	"./glyphs/12/glyph_pause_12.svg": [
		"5q1v",
		12259
	],
	"./glyphs/12/glyph_phone_12.svg": [
		"Z8Xs",
		56317
	],
	"./glyphs/12/glyph_phone_circle_12.svg": [
		"wrgV",
		86158
	],
	"./glyphs/12/glyph_phone_circle_filled_12.svg": [
		"Yho4",
		61907
	],
	"./glyphs/12/glyph_phone_off_12.svg": [
		"U/In",
		2819
	],
	"./glyphs/12/glyph_photo_12.svg": [
		"JB6K",
		93121
	],
	"./glyphs/12/glyph_photo_moment_simple_12.svg": [
		"b7/m",
		41645
	],
	"./glyphs/12/glyph_pin_12.svg": [
		"+qqx",
		19678
	],
	"./glyphs/12/glyph_placeholder_12.svg": [
		"iugS",
		73708
	],
	"./glyphs/12/glyph_play_filled_12.svg": [
		"Hsbh",
		82926
	],
	"./glyphs/12/glyph_rating_12.svg": [
		"mEJz",
		22898
	],
	"./glyphs/12/glyph_repeat_12.svg": [
		"6No6",
		92684
	],
	"./glyphs/12/glyph_reply_12.svg": [
		"7P5E",
		9645
	],
	"./glyphs/12/glyph_reshare_12.svg": [
		"xvaz",
		49985
	],
	"./glyphs/12/glyph_right_12.svg": [
		"0VH8",
		95563
	],
	"./glyphs/12/glyph_settings_12.svg": [
		"WGPc",
		47306
	],
	"./glyphs/12/glyph_shield_moderator_12.svg": [
		"YUO1",
		28054
	],
	"./glyphs/12/glyph_shield_star_12.svg": [
		"ngHT",
		37671
	],
	"./glyphs/12/glyph_statictics_12.svg": [
		"ZFwJ",
		68540
	],
	"./glyphs/12/glyph_stop_music_filled_12.svg": [
		"/qBp",
		73516
	],
	"./glyphs/12/glyph_text_12.svg": [
		"P4sd",
		32416
	],
	"./glyphs/12/glyph_trash_12.svg": [
		"nrUq",
		48851
	],
	"./glyphs/12/glyph_unlock_12.svg": [
		"bGEu",
		5235
	],
	"./glyphs/12/glyph_up_12.svg": [
		"BYA/",
		90562
	],
	"./glyphs/12/glyph_url_12.svg": [
		"4WbM",
		70848
	],
	"./glyphs/12/glyph_user_12.svg": [
		"GROY",
		47724
	],
	"./glyphs/12/glyph_user_tag_12.svg": [
		"rTFp",
		99091
	],
	"./glyphs/12/glyph_users_12.svg": [
		"TB6b",
		50025
	],
	"./glyphs/12/glyph_video_catalog_12.svg": [
		"oQ/q",
		57214
	],
	"./glyphs/12/glyph_videocam_12.svg": [
		"orVt",
		39905
	],
	"./glyphs/12/glyph_view_12.svg": [
		"y35u",
		18106
	],
	"./glyphs/16-20/glyph_1,5x_16_20.svg": [
		"Re3Z",
		76839
	],
	"./glyphs/16-20/glyph_18_plus_16_20.svg": [
		"7+YP",
		5969
	],
	"./glyphs/16-20/glyph_1x_16_20.svg": [
		"1Vwk",
		36776
	],
	"./glyphs/16-20/glyph_2x_16_20.svg": [
		"shBZ",
		41077
	],
	"./glyphs/16-20/glyph_3d_photo_16_20.svg": [
		"ZsSw",
		76291
	],
	"./glyphs/16-20/glyph_5_plus_16_20.svg": [
		"vpa8",
		46676
	],
	"./glyphs/16-20/glyph_5_plus_circle_16_20.svg": [
		"SZuQ",
		4552
	],
	"./glyphs/16-20/glyph_achievements_16_20.svg": [
		"mXpO",
		53307
	],
	"./glyphs/16-20/glyph_add_16_20.svg": [
		"OOcP",
		31838
	],
	"./glyphs/16-20/glyph_add_circle_16_20.svg": [
		"ENR1",
		28279
	],
	"./glyphs/16-20/glyph_alert_circle_16_20.svg": [
		"Mj05",
		44494
	],
	"./glyphs/16-20/glyph_alert_circle_filled_16_20.svg": [
		"+OJN",
		26467
	],
	"./glyphs/16-20/glyph_amount_16_20.svg": [
		"ktk2",
		19171
	],
	"./glyphs/16-20/glyph_army_16_20.svg": [
		"8hOI",
		26088
	],
	"./glyphs/16-20/glyph_arrow_diagonal_16_20.svg": [
		"y7Xy",
		3308
	],
	"./glyphs/16-20/glyph_arrow_diagonal_r_16_20.svg": [
		"xRsB",
		9395
	],
	"./glyphs/16-20/glyph_arrow_down_16_20.svg": [
		"0uEZ",
		14909
	],
	"./glyphs/16-20/glyph_arrow_right_16_20.svg": [
		"sXcA",
		69463
	],
	"./glyphs/16-20/glyph_arrow_up_16_20.svg": [
		"3THL",
		37706
	],
	"./glyphs/16-20/glyph_attach_16_20.svg": [
		"/aBl",
		71284
	],
	"./glyphs/16-20/glyph_ava_decor_16_20.svg": [
		"40kR",
		11611
	],
	"./glyphs/16-20/glyph_back_16_20.svg": [
		"lcat",
		40718
	],
	"./glyphs/16-20/glyph_balloons_16_20.svg": [
		"Q+cj",
		54851
	],
	"./glyphs/16-20/glyph_block_16_20.svg": [
		"slSt",
		36304
	],
	"./glyphs/16-20/glyph_bookmark_16_20.svg": [
		"4iOl",
		3503
	],
	"./glyphs/16-20/glyph_bookmark_c_16_20.svg": [
		"PXBX",
		52181
	],
	"./glyphs/16-20/glyph_bookmark_off_16_20.svg": [
		"twrJ",
		53413
	],
	"./glyphs/16-20/glyph_bot_16_20.svg": [
		"3s5v",
		63444
	],
	"./glyphs/16-20/glyph_brush_16_20.svg": [
		"m4tr",
		80263
	],
	"./glyphs/16-20/glyph_cake_16_20.svg": [
		"2feM",
		69115
	],
	"./glyphs/16-20/glyph_calendar_16_20.svg": [
		"eekz",
		78409
	],
	"./glyphs/16-20/glyph_camera_16_20.svg": [
		"PvID",
		36266
	],
	"./glyphs/16-20/glyph_car_16_20.svg": [
		"MvAC",
		15945
	],
	"./glyphs/16-20/glyph_card_16_20.svg": [
		"ry+y",
		88649
	],
	"./glyphs/16-20/glyph_carousel_calls_16_20.svg": [
		"4oy2",
		7307
	],
	"./glyphs/16-20/glyph_cat_16_20.svg": [
		"Sbim",
		75907
	],
	"./glyphs/16-20/glyph_catalog_16_20.svg": [
		"+Koz",
		76066
	],
	"./glyphs/16-20/glyph_centering_16_20.svg": [
		"nxMi",
		20474
	],
	"./glyphs/16-20/glyph_chat_background_16_20.svg": [
		"sNVD",
		83826
	],
	"./glyphs/16-20/glyph_check_16_20.svg": [
		"r0Ho",
		23231
	],
	"./glyphs/16-20/glyph_check_circle_off_16_20.svg": [
		"Yn6f",
		40826
	],
	"./glyphs/16-20/glyph_check_circle_on_16_20.svg": [
		"8TLf",
		6606
	],
	"./glyphs/16-20/glyph_checkbox_16_20.svg": [
		"ND2t",
		66744
	],
	"./glyphs/16-20/glyph_checkbox_off_16_20.svg": [
		"M1Fs",
		86546
	],
	"./glyphs/16-20/glyph_checks_16_20.svg": [
		"4E83",
		28000
	],
	"./glyphs/16-20/glyph_clear_16_20.svg": [
		"83JY",
		58564
	],
	"./glyphs/16-20/glyph_clock_16_20.svg": [
		"grhk",
		49329
	],
	"./glyphs/16-20/glyph_clock_filled_16_20.svg": [
		"V6nQ",
		87038
	],
	"./glyphs/16-20/glyph_close_16_20.svg": [
		"zl5z",
		2067
	],
	"./glyphs/16-20/glyph_close_circle_16_20.svg": [
		"Sj0p",
		64148
	],
	"./glyphs/16-20/glyph_close_circle_filled_16_20.svg": [
		"uYBR",
		39109
	],
	"./glyphs/16-20/glyph_comment_16_20.svg": [
		"OpR6",
		82332
	],
	"./glyphs/16-20/glyph_comment_off_16_20.svg": [
		"hEK8",
		84998
	],
	"./glyphs/16-20/glyph_competition_16_20.svg": [
		"CG0S",
		6746
	],
	"./glyphs/16-20/glyph_compose_16_20.svg": [
		"S4Vt",
		77443
	],
	"./glyphs/16-20/glyph_constructor_canvaz_16_20.svg": [
		"ht6y",
		34069
	],
	"./glyphs/16-20/glyph_copy_16_20.svg": [
		"kiyR",
		40820
	],
	"./glyphs/16-20/glyph_crop_16_20.svg": [
		"/jTI",
		37577
	],
	"./glyphs/16-20/glyph_cut_16_20.svg": [
		"6sf9",
		11775
	],
	"./glyphs/16-20/glyph_day_16_20.svg": [
		"dJzt",
		83909
	],
	"./glyphs/16-20/glyph_description_16_20.svg": [
		"oEF6",
		34613
	],
	"./glyphs/16-20/glyph_developer_16_20.svg": [
		"apWx",
		81645
	],
	"./glyphs/16-20/glyph_devs_16_20.svg": [
		"XQGm",
		76195
	],
	"./glyphs/16-20/glyph_discovery_16_20.svg": [
		"cYFv",
		95749
	],
	"./glyphs/16-20/glyph_discussions_16_20.svg": [
		"13lG",
		59640
	],
	"./glyphs/16-20/glyph_discussions_off_16_20.svg": [
		"3Ejb",
		44978
	],
	"./glyphs/16-20/glyph_dislike_16_20.svg": [
		"B6oQ",
		30146
	],
	"./glyphs/16-20/glyph_dislike_filled_16_20.svg": [
		"4cX8",
		27247
	],
	"./glyphs/16-20/glyph_divider_16_20.svg": [
		"Ulw+",
		55952
	],
	"./glyphs/16-20/glyph_docs_16_20.svg": [
		"zQku",
		35378
	],
	"./glyphs/16-20/glyph_done_16_20.svg": [
		"Me+u",
		15223
	],
	"./glyphs/16-20/glyph_done_checkbox_16_20.svg": [
		"AzmP",
		82039
	],
	"./glyphs/16-20/glyph_down_16_20.svg": [
		"3dO3",
		7915
	],
	"./glyphs/16-20/glyph_download_16_20.svg": [
		"NUBr",
		85407
	],
	"./glyphs/16-20/glyph_download_off_16_20.svg": [
		"pV5w",
		84213
	],
	"./glyphs/16-20/glyph_earth_16_20.svg": [
		"e+Iq",
		39003
	],
	"./glyphs/16-20/glyph_edit_16_20.svg": [
		"rVVy",
		98299
	],
	"./glyphs/16-20/glyph_education_16_20.svg": [
		"Qs66",
		87313
	],
	"./glyphs/16-20/glyph_equalize_max_16_20.svg": [
		"n6f9",
		88674
	],
	"./glyphs/16-20/glyph_equalize_middle_16_20.svg": [
		"JapZ",
		41685
	],
	"./glyphs/16-20/glyph_equalize_min_16_20.svg": [
		"w9mC",
		39128
	],
	"./glyphs/16-20/glyph_explicit_16_20.svg": [
		"ZXGt",
		26739
	],
	"./glyphs/16-20/glyph_favourite_16_20.svg": [
		"315g",
		81406
	],
	"./glyphs/16-20/glyph_favourite_filled_16_20.svg": [
		"0PsJ",
		6291
	],
	"./glyphs/16-20/glyph_favourite_off_16_20.svg": [
		"wUvV",
		96664
	],
	"./glyphs/16-20/glyph_feed_16_20.svg": [
		"d9N+",
		30923
	],
	"./glyphs/16-20/glyph_feed_follow_16_20.svg": [
		"m15O",
		68963
	],
	"./glyphs/16-20/glyph_feed_follow_on_16_20.svg": [
		"CpY1",
		68987
	],
	"./glyphs/16-20/glyph_feed_off_16_20.svg": [
		"MiS1",
		33905
	],
	"./glyphs/16-20/glyph_file_16_20.svg": [
		"Vf+J",
		32961
	],
	"./glyphs/16-20/glyph_file_filled_16_20.svg": [
		"hsdP",
		93006
	],
	"./glyphs/16-20/glyph_filter_16_20.svg": [
		"Eoqy",
		93869
	],
	"./glyphs/16-20/glyph_fire_16_20.svg": [
		"iJQl",
		74979
	],
	"./glyphs/16-20/glyph_fire_filled_с_16_20.svg": [
		"W3VS",
		2484
	],
	"./glyphs/16-20/glyph_fish_16_20.svg": [
		"dSQI",
		94669
	],
	"./glyphs/16-20/glyph_flag_16_20.svg": [
		"pnxx",
		68709
	],
	"./glyphs/16-20/glyph_flash_16_20.svg": [
		"WFlT",
		9629
	],
	"./glyphs/16-20/glyph_flower_16_20.svg": [
		"hU2S",
		99762
	],
	"./glyphs/16-20/glyph_flower_chamomile_16_20.svg": [
		"9qO5",
		65002
	],
	"./glyphs/16-20/glyph_flyer_16_20.svg": [
		"1vmJ",
		54909
	],
	"./glyphs/16-20/glyph_follow_16_20.svg": [
		"F/R5",
		40652
	],
	"./glyphs/16-20/glyph_food_tag_fill_16_20.svg": [
		"X//R",
		40912
	],
	"./glyphs/16-20/glyph_food_tag_outline_16_20.svg": [
		"LCHC",
		13441
	],
	"./glyphs/16-20/glyph_forward_16_20.svg": [
		"VFgu",
		11188
	],
	"./glyphs/16-20/glyph_fullscreen_16_20.svg": [
		"WBpJ",
		83488
	],
	"./glyphs/16-20/glyph_games_16_20.svg": [
		"Xj3x",
		33798
	],
	"./glyphs/16-20/glyph_geo_16_20.svg": [
		"T0KF",
		43148
	],
	"./glyphs/16-20/glyph_gif_16_20.svg": [
		"LnUJ",
		40529
	],
	"./glyphs/16-20/glyph_gif_sticker_16_20.svg": [
		"2cYI",
		12441
	],
	"./glyphs/16-20/glyph_gift_16_20.svg": [
		"X0Io",
		9649
	],
	"./glyphs/16-20/glyph_gift_heart_16_20.svg": [
		"qmb/",
		15216
	],
	"./glyphs/16-20/glyph_globe_16_20.svg": [
		"kj18",
		38052
	],
	"./glyphs/16-20/glyph_handiwork_tag_fill_16_20.svg": [
		"Ko3U",
		70709
	],
	"./glyphs/16-20/glyph_handiwork_tag_outline_16_20.svg": [
		"1pcb",
		41594
	],
	"./glyphs/16-20/glyph_headphones_16_20.svg": [
		"m8/Y",
		11406
	],
	"./glyphs/16-20/glyph_heart_add_16_20.svg": [
		"v4rD",
		21335
	],
	"./glyphs/16-20/glyph_heart_cross_16_20.svg": [
		"xKhW",
		42514
	],
	"./glyphs/16-20/glyph_hearts_2_16_20.svg": [
		"WPfZ",
		26163
	],
	"./glyphs/16-20/glyph_help_circle_16_20.svg": [
		"DqGk",
		51551
	],
	"./glyphs/16-20/glyph_help_circle_filled_16_20.svg": [
		"9EgF",
		26328
	],
	"./glyphs/16-20/glyph_history_backward_16_20.svg": [
		"EN3v",
		93515
	],
	"./glyphs/16-20/glyph_history_media_backward_16_20.svg": [
		"mBPC",
		61284
	],
	"./glyphs/16-20/glyph_hobbies_16_20.svg": [
		"kBmh",
		89343
	],
	"./glyphs/16-20/glyph_home_16_20.svg": [
		"pB84",
		85898
	],
	"./glyphs/16-20/glyph_indeterminate_16_20.svg": [
		"r76P",
		98326
	],
	"./glyphs/16-20/glyph_info_circle_16_20.svg": [
		"mexa",
		84
	],
	"./glyphs/16-20/glyph_invisible_16_20.svg": [
		"cWQv",
		38174
	],
	"./glyphs/16-20/glyph_klass_16_20.svg": [
		"3PLi",
		1575
	],
	"./glyphs/16-20/glyph_klass_filled_16_20.svg": [
		"X/p0",
		83600
	],
	"./glyphs/16-20/glyph_klass_groups_16_20.svg": [
		"IZ0x",
		82124
	],
	"./glyphs/16-20/glyph_like_16_20.svg": [
		"UC7T",
		42118
	],
	"./glyphs/16-20/glyph_like_filled_16_20.svg": [
		"TSlk",
		24715
	],
	"./glyphs/16-20/glyph_link_external_16_20.svg": [
		"xogx",
		66597
	],
	"./glyphs/16-20/glyph_list_16_20.svg": [
		"icPo",
		88063
	],
	"./glyphs/16-20/glyph_location_16_20.svg": [
		"6FGd",
		92378
	],
	"./glyphs/16-20/glyph_lock_16_20.svg": [
		"wLip",
		64114
	],
	"./glyphs/16-20/glyph_logo_ok_16_20.svg": [
		"ogwL",
		43037
	],
	"./glyphs/16-20/glyph_logout_16_20.svg": [
		"7BEc",
		23177
	],
	"./glyphs/16-20/glyph_lotus_16_20.svg": [
		"v8Qt",
		81274
	],
	"./glyphs/16-20/glyph_loudspeaker_16_20.svg": [
		"BMFO",
		53072
	],
	"./glyphs/16-20/glyph_market_16_20.svg": [
		"mfz+",
		167
	],
	"./glyphs/16-20/glyph_masters_16_20.svg": [
		"hSUt",
		91162
	],
	"./glyphs/16-20/glyph_med_tag_fill_16_20.svg": [
		"Q6bQ",
		71306
	],
	"./glyphs/16-20/glyph_med_tag_outline_16_20.svg": [
		"krOD",
		43611
	],
	"./glyphs/16-20/glyph_mention_16_20.svg": [
		"5bFo",
		90005
	],
	"./glyphs/16-20/glyph_mention_off_16_20.svg": [
		"xzv2",
		1787
	],
	"./glyphs/16-20/glyph_menu_16_20.svg": [
		"M81D",
		75458
	],
	"./glyphs/16-20/glyph_message_16_20.svg": [
		"T2Po",
		26602
	],
	"./glyphs/16-20/glyph_message_new_16_20.svg": [
		"Pzbk",
		86145
	],
	"./glyphs/16-20/glyph_message_off_16_20.svg": [
		"wJeL",
		36548
	],
	"./glyphs/16-20/glyph_message_readed_16_20.svg": [
		"aVoU",
		62900
	],
	"./glyphs/16-20/glyph_microphone_16_20.svg": [
		"r2FG",
		86455
	],
	"./glyphs/16-20/glyph_microphone_karaoke_16_20.svg": [
		"wdxO",
		3676
	],
	"./glyphs/16-20/glyph_microphone_off_16_20.svg": [
		"qySH",
		66125
	],
	"./glyphs/16-20/glyph_mini_down_16_20.svg": [
		"C1aU",
		34683
	],
	"./glyphs/16-20/glyph_mini_up_16_20.svg": [
		"6x5Z",
		67684
	],
	"./glyphs/16-20/glyph_minus_16_20.svg": [
		"lg+H",
		73951
	],
	"./glyphs/16-20/glyph_minzdrav_tag_fill_16_20.svg": [
		"WbBT",
		39255
	],
	"./glyphs/16-20/glyph_minzdrav_tag_outline_16_20.svg": [
		"8VwR",
		13380
	],
	"./glyphs/16-20/glyph_mobile_16_20.svg": [
		"ncOS",
		67621
	],
	"./glyphs/16-20/glyph_moment_16_20.svg": [
		"rr3b",
		68331
	],
	"./glyphs/16-20/glyph_montage_studio_16_20.svg": [
		"HDYf",
		48043
	],
	"./glyphs/16-20/glyph_more_16_20.svg": [
		"9b4c",
		15008
	],
	"./glyphs/16-20/glyph_more_circle_filled_16_20.svg": [
		"cJhw",
		57914
	],
	"./glyphs/16-20/glyph_more_vertical_16_20.svg": [
		"CbLn",
		31535
	],
	"./glyphs/16-20/glyph_move_cover_16_20.svg": [
		"DUc+",
		51556
	],
	"./glyphs/16-20/glyph_movie_16_20.svg": [
		"4lJF",
		61755
	],
	"./glyphs/16-20/glyph_music_16_20.svg": [
		"Tgd7",
		13950
	],
	"./glyphs/16-20/glyph_music_album_16_20.svg": [
		"SHP2",
		75214
	],
	"./glyphs/16-20/glyph_music_album_filled_16_20.svg": [
		"VoBj",
		93027
	],
	"./glyphs/16-20/glyph_music_note_16_20.svg": [
		"WxFl",
		17231
	],
	"./glyphs/16-20/glyph_music_radio_16_20.svg": [
		"erLN",
		61482
	],
	"./glyphs/16-20/glyph_new_16_20.svg": [
		"osnn",
		44529
	],
	"./glyphs/16-20/glyph_news_tag_fill_16_20.svg": [
		"egqc",
		53732
	],
	"./glyphs/16-20/glyph_news_tag_outline_16_20.svg": [
		"WFkx",
		97828
	],
	"./glyphs/16-20/glyph_next_filled_16_20.svg": [
		"LEI2",
		28185
	],
	"./glyphs/16-20/glyph_night_16_20.svg": [
		"+j8m",
		15321
	],
	"./glyphs/16-20/glyph_notes_16_20.svg": [
		"Y5wO",
		45348
	],
	"./glyphs/16-20/glyph_notifications_16_20.svg": [
		"MBCA",
		86035
	],
	"./glyphs/16-20/glyph_notifications_2_16_20.svg": [
		"u16s",
		95144
	],
	"./glyphs/16-20/glyph_notifications_off_16_20.svg": [
		"rl98",
		51161
	],
	"./glyphs/16-20/glyph_notifications_web_16_20.svg": [
		"F3Ah",
		64188
	],
	"./glyphs/16-20/glyph_ok_circle_16_20.svg": [
		"I0/t",
		76146
	],
	"./glyphs/16-20/glyph_ok_live_16_20.svg": [
		"IcPi",
		82348
	],
	"./glyphs/16-20/glyph_ok_star_16_20.svg": [
		"DOOL",
		56062
	],
	"./glyphs/16-20/glyph_pause_16_20.svg": [
		"GhPK",
		70357
	],
	"./glyphs/16-20/glyph_pause_circle_16_20.svg": [
		"C//f",
		5330
	],
	"./glyphs/16-20/glyph_pause_small_filled_16_20.svg": [
		"LQYZ",
		22494
	],
	"./glyphs/16-20/glyph_percent_16_20.svg": [
		"Xulr",
		36320
	],
	"./glyphs/16-20/glyph_phone_16_20.svg": [
		"3uSN",
		4795
	],
	"./glyphs/16-20/glyph_phone_add_16_20.svg": [
		"wCv+",
		95487
	],
	"./glyphs/16-20/glyph_phone_circle_filled_16_20.svg": [
		"43f2",
		23965
	],
	"./glyphs/16-20/glyph_phone_off_16_20.svg": [
		"3JoU",
		56897
	],
	"./glyphs/16-20/glyph_photo_16_20.svg": [
		"6YDQ",
		65779
	],
	"./glyphs/16-20/glyph_photo_add_16_20.svg": [
		"4VOR",
		22407
	],
	"./glyphs/16-20/glyph_photo_album_16_20.svg": [
		"IvtG",
		63199
	],
	"./glyphs/16-20/glyph_photo_cover_install_16_20.svg": [
		"hOqX",
		45203
	],
	"./glyphs/16-20/glyph_photo_moment_add_16_20.svg": [
		"H3xN",
		50952
	],
	"./glyphs/16-20/glyph_photo_moment_clock_16_20.svg": [
		"a4UK",
		13779
	],
	"./glyphs/16-20/glyph_photo_off_16_20.svg": [
		"IlsV",
		74041
	],
	"./glyphs/16-20/glyph_photo_web_16_20.svg": [
		"q2V5",
		87068
	],
	"./glyphs/16-20/glyph_pin_16_20.svg": [
		"MyJo",
		82426
	],
	"./glyphs/16-20/glyph_pin_off_16_20.svg": [
		"Yjbi",
		14100
	],
	"./glyphs/16-20/glyph_placeholder_16_20.svg": [
		"yKo0",
		43580
	],
	"./glyphs/16-20/glyph_play_16_20.svg": [
		"7Y9l",
		27957
	],
	"./glyphs/16-20/glyph_play_circle_16_20.svg": [
		"gdUF",
		42130
	],
	"./glyphs/16-20/glyph_play_filled_16_20.svg": [
		"bqp8",
		11370
	],
	"./glyphs/16-20/glyph_play_next_16_20.svg": [
		"5Rr9",
		90441
	],
	"./glyphs/16-20/glyph_play_small_filled_16_20.svg": [
		"cz5S",
		26718
	],
	"./glyphs/16-20/glyph_playlist_16_20.svg": [
		"wtAD",
		63817
	],
	"./glyphs/16-20/glyph_playlist_add_16_20.svg": [
		"m7yw",
		34569
	],
	"./glyphs/16-20/glyph_pot_16_20.svg": [
		"JtLT",
		5126
	],
	"./glyphs/16-20/glyph_previous_filled_16_20.svg": [
		"yYts",
		72661
	],
	"./glyphs/16-20/glyph_print_16_20.svg": [
		"SbtS",
		85690
	],
	"./glyphs/16-20/glyph_privacy_16_20.svg": [
		"m9tZ",
		50071
	],
	"./glyphs/16-20/glyph_promote_16_20.svg": [
		"oc7D",
		81635
	],
	"./glyphs/16-20/glyph_question_add_16_20.svg": [
		"4MoD",
		83559
	],
	"./glyphs/16-20/glyph_question_cross_16_20.svg": [
		"0b4y",
		40258
	],
	"./glyphs/16-20/glyph_question_moments_16_20.svg": [
		"0fS5",
		4473
	],
	"./glyphs/16-20/glyph_quick_delivery_16_20.svg": [
		"BxVh",
		90991
	],
	"./glyphs/16-20/glyph_quote_16_20.svg": [
		"XG9+",
		63867
	],
	"./glyphs/16-20/glyph_rating_16_20.svg": [
		"ZBcS",
		91052
	],
	"./glyphs/16-20/glyph_read_16_20.svg": [
		"UIJ2",
		79027
	],
	"./glyphs/16-20/glyph_readed_16_20.svg": [
		"GCKF",
		99300
	],
	"./glyphs/16-20/glyph_record_16_20.svg": [
		"sNGH",
		43868
	],
	"./glyphs/16-20/glyph_refresh_16_20.svg": [
		"BO+2",
		15150
	],
	"./glyphs/16-20/glyph_religion_tag_fill_16_20.svg": [
		"HYi7",
		95395
	],
	"./glyphs/16-20/glyph_religion_tag_outline_16_20.svg": [
		"7Bbq",
		68816
	],
	"./glyphs/16-20/glyph_repeat_16_20.svg": [
		"s3TP",
		14146
	],
	"./glyphs/16-20/glyph_reply_16_20.svg": [
		"tJqt",
		20443
	],
	"./glyphs/16-20/glyph_repost_16_20.svg": [
		"mdfh",
		80710
	],
	"./glyphs/16-20/glyph_reshare_16_20.svg": [
		"GRpe",
		15443
	],
	"./glyphs/16-20/glyph_right_16_20.svg": [
		"t26B",
		74789
	],
	"./glyphs/16-20/glyph_rotate_photo_clockwise_16_20.svg": [
		"m3xq",
		92024
	],
	"./glyphs/16-20/glyph_rotate_photo_counterclockwise_16_20.svg": [
		"HscZ",
		47350
	],
	"./glyphs/16-20/glyph_rubl_16_20.svg": [
		"Dr0g",
		52866
	],
	"./glyphs/16-20/glyph_rubl_circle_16_20.svg": [
		"ElUL",
		61051
	],
	"./glyphs/16-20/glyph_screen_sharing_off_16_20.svg": [
		"uW+W",
		41676
	],
	"./glyphs/16-20/glyph_screen_sharing_on_16_20.svg": [
		"9+AU",
		27576
	],
	"./glyphs/16-20/glyph_search_ zoom_16_20.svg": [
		"nnbZ",
		72411
	],
	"./glyphs/16-20/glyph_search_16_20.svg": [
		"vIyp",
		64691
	],
	"./glyphs/16-20/glyph_send_filled_16_20.svg": [
		"LOHj",
		71974
	],
	"./glyphs/16-20/glyph_serials_16_20.svg": [
		"JQTv",
		17132
	],
	"./glyphs/16-20/glyph_services_16_20.svg": [
		"+nIm",
		79903
	],
	"./glyphs/16-20/glyph_settings_16_20.svg": [
		"eqLb",
		23156
	],
	"./glyphs/16-20/glyph_share_16_20.svg": [
		"0wFr",
		52318
	],
	"./glyphs/16-20/glyph_share_to_user_16_20.svg": [
		"MFMM",
		3960
	],
	"./glyphs/16-20/glyph_shield_admin_16_20.svg": [
		"WgDA",
		60800
	],
	"./glyphs/16-20/glyph_shield_moderator_16_20.svg": [
		"IEOL",
		90696
	],
	"./glyphs/16-20/glyph_shield_moderator_change_16_20.svg": [
		"X5ZV",
		37849
	],
	"./glyphs/16-20/glyph_shield_moderator_off_16_20.svg": [
		"etAz",
		19586
	],
	"./glyphs/16-20/glyph_shield_moderator_super_16_20.svg": [
		"lJyl",
		35368
	],
	"./glyphs/16-20/glyph_shield_safety_16_20.svg": [
		"vGk0",
		6975
	],
	"./glyphs/16-20/glyph_shield_star_16_20.svg": [
		"ieON",
		63429
	],
	"./glyphs/16-20/glyph_shopping_cart_16_20.svg": [
		"nnDk",
		55494
	],
	"./glyphs/16-20/glyph_shuffle_16_20.svg": [
		"X9yX",
		40656
	],
	"./glyphs/16-20/glyph_smile_16_20.svg": [
		"YbN2",
		46803
	],
	"./glyphs/16-20/glyph_smile_filled_16_20.svg": [
		"iO8E",
		65524
	],
	"./glyphs/16-20/glyph_smile_fine_16_20.svg": [
		"d4rW",
		37696
	],
	"./glyphs/16-20/glyph_smile_sad_16_20.svg": [
		"ukdk",
		21862
	],
	"./glyphs/16-20/glyph_smile_sad_filled_16_20.svg": [
		"jHRa",
		36907
	],
	"./glyphs/16-20/glyph_smile_square_16_20.svg": [
		"FDau",
		72973
	],
	"./glyphs/16-20/glyph_smile_square_filled_16_20.svg": [
		"r1O+",
		4562
	],
	"./glyphs/16-20/glyph_sort_16_20.svg": [
		"7C3K",
		83515
	],
	"./glyphs/16-20/glyph_sound_16_20.svg": [
		"juwd",
		53346
	],
	"./glyphs/16-20/glyph_sound_bluetooth_16_20.svg": [
		"MEpa",
		65717
	],
	"./glyphs/16-20/glyph_sound_minimal_16_20.svg": [
		"sRn8",
		87710
	],
	"./glyphs/16-20/glyph_sound_off_16_20.svg": [
		"3nI0",
		45276
	],
	"./glyphs/16-20/glyph_sparkle_16_20.svg": [
		"iLTN",
		60309
	],
	"./glyphs/16-20/glyph_sparkle_square_16_20.svg": [
		"aO/u",
		90111
	],
	"./glyphs/16-20/glyph_sparkle_square_filled_16_20.svg": [
		"XHKA",
		24056
	],
	"./glyphs/16-20/glyph_sparkles_16_20.svg": [
		"rj2H",
		87878
	],
	"./glyphs/16-20/glyph_sport_16_20.svg": [
		"Fog2",
		31389
	],
	"./glyphs/16-20/glyph_sprout_16_20.svg": [
		"e/+O",
		48756
	],
	"./glyphs/16-20/glyph_star_16_20.svg": [
		"cYIb",
		60383
	],
	"./glyphs/16-20/glyph_statictics_16_20.svg": [
		"d9PJ",
		92966
	],
	"./glyphs/16-20/glyph_sticker_create_16_20.svg": [
		"Yg+w",
		90459
	],
	"./glyphs/16-20/glyph_stop_16_20.svg": [
		"p4ms",
		80159
	],
	"./glyphs/16-20/glyph_stop_circle_16_20.svg": [
		"ag4D",
		35456
	],
	"./glyphs/16-20/glyph_stop_music_16_20.svg": [
		"dZuw",
		45723
	],
	"./glyphs/16-20/glyph_stop_music_filled_16_20.svg": [
		"+X3a",
		14860
	],
	"./glyphs/16-20/glyph_suitcase_16_20.svg": [
		"ZZq0",
		98500
	],
	"./glyphs/16-20/glyph_switch_off_16_20.svg": [
		"3qF5",
		68817
	],
	"./glyphs/16-20/glyph_tags_16_20.svg": [
		"kvki",
		63072
	],
	"./glyphs/16-20/glyph_tangle_16_20.svg": [
		"uBEQ",
		66506
	],
	"./glyphs/16-20/glyph_text_16_20.svg": [
		"UQzm",
		50074
	],
	"./glyphs/16-20/glyph_text_bold_16_20.svg": [
		"zuNf",
		20078
	],
	"./glyphs/16-20/glyph_text_code_16_20.svg": [
		"OgKD",
		44700
	],
	"./glyphs/16-20/glyph_text_cross_out_16_20.svg": [
		"fHPK",
		72826
	],
	"./glyphs/16-20/glyph_text_header_16_20.svg": [
		"69J7",
		84300
	],
	"./glyphs/16-20/glyph_text_italic_16_20.svg": [
		"0fe0",
		24295
	],
	"./glyphs/16-20/glyph_text_subheader_16_20.svg": [
		"A3tD",
		43014
	],
	"./glyphs/16-20/glyph_text_underline_16_20.svg": [
		"6AQN",
		87115
	],
	"./glyphs/16-20/glyph_topic_16_20.svg": [
		"PGqC",
		51154
	],
	"./glyphs/16-20/glyph_trash_16_20.svg": [
		"suam",
		83109
	],
	"./glyphs/16-20/glyph_tv_show_16_20.svg": [
		"YzLq",
		44249
	],
	"./glyphs/16-20/glyph_undo_16_20.svg": [
		"57Nw",
		52161
	],
	"./glyphs/16-20/glyph_unload_statistic_16_20.svg": [
		"Guam",
		46457
	],
	"./glyphs/16-20/glyph_unlock_16_20.svg": [
		"P6RP",
		26043
	],
	"./glyphs/16-20/glyph_unreaded_16_20.svg": [
		"aUM2",
		96169
	],
	"./glyphs/16-20/glyph_up_16_20.svg": [
		"I2S9",
		33684
	],
	"./glyphs/16-20/glyph_upload_16_20.svg": [
		"LkJI",
		74456
	],
	"./glyphs/16-20/glyph_url_16_20.svg": [
		"gATc",
		464
	],
	"./glyphs/16-20/glyph_url_add_16_20.svg": [
		"LkF7",
		98280
	],
	"./glyphs/16-20/glyph_user_16_20.svg": [
		"PCvM",
		88966
	],
	"./glyphs/16-20/glyph_user_add_16_20.svg": [
		"ojv3",
		34498
	],
	"./glyphs/16-20/glyph_user_added_16_20.svg": [
		"oGXu",
		45961
	],
	"./glyphs/16-20/glyph_user_block_16_20.svg": [
		"DzwI",
		80356
	],
	"./glyphs/16-20/glyph_user_contact_16_20.svg": [
		"CjYP",
		86407
	],
	"./glyphs/16-20/glyph_user_gift_16_20.svg": [
		"XaG9",
		7509
	],
	"./glyphs/16-20/glyph_user_hide_16_20.svg": [
		"l6s0",
		1795
	],
	"./glyphs/16-20/glyph_user_online_16_20.svg": [
		"n9sD",
		33394
	],
	"./glyphs/16-20/glyph_user_request_16_20.svg": [
		"v5JW",
		10660
	],
	"./glyphs/16-20/glyph_user_request_2_16_20.svg": [
		"c9pX",
		39451
	],
	"./glyphs/16-20/glyph_user_share_16_20.svg": [
		"3nQF",
		50906
	],
	"./glyphs/16-20/glyph_user_square_16_20.svg": [
		"vlOn",
		98566
	],
	"./glyphs/16-20/glyph_user_star_16_20.svg": [
		"MQos",
		98595
	],
	"./glyphs/16-20/glyph_user_tag_16_20.svg": [
		"xml6",
		29107
	],
	"./glyphs/16-20/glyph_users_16_20.svg": [
		"MiTO",
		93487
	],
	"./glyphs/16-20/glyph_users_3_16_20.svg": [
		"Wkft",
		5125
	],
	"./glyphs/16-20/glyph_users_hide_16_20.svg": [
		"O549",
		40508
	],
	"./glyphs/16-20/glyph_uslugi_16_20.svg": [
		"LU3f",
		69646
	],
	"./glyphs/16-20/glyph_video_16_20.svg": [
		"rDTv",
		10174
	],
	"./glyphs/16-20/glyph_video_add_16_20.svg": [
		"ECjB",
		89706
	],
	"./glyphs/16-20/glyph_video_blog_16_20.svg": [
		"kBfl",
		27615
	],
	"./glyphs/16-20/glyph_video_catalog_16_20.svg": [
		"CjCr",
		21342
	],
	"./glyphs/16-20/glyph_video_file_16_20.svg": [
		"t8CA",
		78781
	],
	"./glyphs/16-20/glyph_video_kids_16_20.svg": [
		"jngg",
		83656
	],
	"./glyphs/16-20/glyph_video_note_16_20.svg": [
		"99+M",
		22991
	],
	"./glyphs/16-20/glyph_videocam_16_20.svg": [
		"WIbH",
		4749
	],
	"./glyphs/16-20/glyph_videocam_off_16_20.svg": [
		"jMm3",
		85875
	],
	"./glyphs/16-20/glyph_videocam_translation_16_20.svg": [
		"19Yw",
		59593
	],
	"./glyphs/16-20/glyph_videocam_translation_add_16_20.svg": [
		"y2Xf",
		17449
	],
	"./glyphs/16-20/glyph_view_16_20.svg": [
		"POEe",
		99920
	],
	"./glyphs/16-20/glyph_view_off_16_20.svg": [
		"vTqh",
		36586
	],
	"./glyphs/16-20/glyph_voting_16_20.svg": [
		"RVdl",
		19626
	],
	"./glyphs/16-20/glyph_wallet_16_20.svg": [
		"fIGR",
		12012
	],
	"./glyphs/16-20/glyph_warning_triangle_16_20.svg": [
		"R+p1",
		7096
	],
	"./glyphs/16-20/glyph_web_16_20.svg": [
		"nWcw",
		92001
	],
	"./glyphs/16-20/glyph_work_16_20.svg": [
		"pnH1",
		57596
	],
	"./glyphs/20/glyph_close_20.svg": [
		"ETkt",
		85195
	],
	"./glyphs/24-48/glyph_1,5x_24+.svg": [
		"+YAO",
		85821
	],
	"./glyphs/24-48/glyph_18_plus_24+.svg": [
		"LHiJ",
		80837
	],
	"./glyphs/24-48/glyph_1x_24+.svg": [
		"eCIL",
		58862
	],
	"./glyphs/24-48/glyph_2x_24+.svg": [
		"5uf5",
		63091
	],
	"./glyphs/24-48/glyph_3d_photo_24+.svg": [
		"i6nm",
		5745
	],
	"./glyphs/24-48/glyph_5_plus_circle_24+.svg": [
		"GbUr",
		29084
	],
	"./glyphs/24-48/glyph_achievements_24+.svg": [
		"5+O4",
		52273
	],
	"./glyphs/24-48/glyph_actions_24+.svg": [
		"25Zp",
		33162
	],
	"./glyphs/24-48/glyph_ad_link_24+.svg": [
		"r67/",
		19161
	],
	"./glyphs/24-48/glyph_add_24+.svg": [
		"nCht",
		88738
	],
	"./glyphs/24-48/glyph_add_album_24+.svg": [
		"TL86",
		88638
	],
	"./glyphs/24-48/glyph_add_circle_24+.svg": [
		"TXw4",
		72285
	],
	"./glyphs/24-48/glyph_add_square_24+.svg": [
		"T3qB",
		41512
	],
	"./glyphs/24-48/glyph_airpot_24+.svg": [
		"Q0CH",
		86576
	],
	"./glyphs/24-48/glyph_alert_circle_24+.svg": [
		"3IgH",
		70936
	],
	"./glyphs/24-48/glyph_alert_circle_filled_24+.svg": [
		"AU0L",
		32751
	],
	"./glyphs/24-48/glyph_align_center_24+.svg": [
		"OLjx",
		25808
	],
	"./glyphs/24-48/glyph_align_justify_24+.svg": [
		"VwSa",
		26449
	],
	"./glyphs/24-48/glyph_align_left_24+.svg": [
		"tDgl",
		79708
	],
	"./glyphs/24-48/glyph_align_right_24+.svg": [
		"Vvpn",
		77631
	],
	"./glyphs/24-48/glyph_all_inclusive_24+.svg": [
		"WZmg",
		17973
	],
	"./glyphs/24-48/glyph_appletv_24+.svg": [
		"Pfnh",
		84437
	],
	"./glyphs/24-48/glyph_army_24+.svg": [
		"6MTR",
		79306
	],
	"./glyphs/24-48/glyph_arrow_circle_24+.svg": [
		"vWtg",
		27763
	],
	"./glyphs/24-48/glyph_arrow_down_24+.svg": [
		"imD8",
		27151
	],
	"./glyphs/24-48/glyph_arrow_left_24+.svg": [
		"tlAg",
		99364
	],
	"./glyphs/24-48/glyph_arrow_redo_24+.svg": [
		"Ztxj",
		99611
	],
	"./glyphs/24-48/glyph_arrow_right_24+.svg": [
		"KPaW",
		74887
	],
	"./glyphs/24-48/glyph_arrow_undo_24+.svg": [
		"iTYC",
		20409
	],
	"./glyphs/24-48/glyph_arrow_up_24+.svg": [
		"/q/G",
		84652
	],
	"./glyphs/24-48/glyph_attach_24+.svg": [
		"ijtM",
		1842
	],
	"./glyphs/24-48/glyph_ava_decor_24+.svg": [
		"ggXm",
		36827
	],
	"./glyphs/24-48/glyph_avtoplay_24+.svg": [
		"VRSw",
		433
	],
	"./glyphs/24-48/glyph_back_24+.svg": [
		"UXHP",
		24568
	],
	"./glyphs/24-48/glyph_back_big_24+.svg": [
		"w1DU",
		99903
	],
	"./glyphs/24-48/glyph_backspace_24+.svg": [
		"OWXA",
		50646
	],
	"./glyphs/24-48/glyph_balloons_24+.svg": [
		"mkGZ",
		25593
	],
	"./glyphs/24-48/glyph_bell_24+.svg": [
		"0Dlu",
		98446
	],
	"./glyphs/24-48/glyph_black_field_off_24+.svg": [
		"rm7A",
		91889
	],
	"./glyphs/24-48/glyph_black_field_on_24+.svg": [
		"vM4c",
		62013
	],
	"./glyphs/24-48/glyph_block_24+.svg": [
		"xH9p",
		88048
	],
	"./glyphs/24-48/glyph_bluetooth_24+.svg": [
		"mKnO",
		18517
	],
	"./glyphs/24-48/glyph_book_24+.svg": [
		"wRHp",
		57826
	],
	"./glyphs/24-48/glyph_bookmark_24+.svg": [
		"7g/c",
		5529
	],
	"./glyphs/24-48/glyph_bookmark_off_24+.svg": [
		"onbmY",
		7247
	],
	"./glyphs/24-48/glyph_bookmarl_c_24+.svg": [
		"BRlX",
		89836
	],
	"./glyphs/24-48/glyph_boomerang_24+.svg": [
		"3yyl",
		14247
	],
	"./glyphs/24-48/glyph_bouquet_24+.svg": [
		"OSod",
		15596
	],
	"./glyphs/24-48/glyph_box_24+.svg": [
		"Ygp0",
		57344
	],
	"./glyphs/24-48/glyph_brush_24+.svg": [
		"SvcI",
		6003
	],
	"./glyphs/24-48/glyph_brush_retouch_24+.svg": [
		"6F7g",
		6906
	],
	"./glyphs/24-48/glyph_cake_24+.svg": [
		"hbbp",
		96273
	],
	"./glyphs/24-48/glyph_calendar_24+.svg": [
		"Ffzk",
		483
	],
	"./glyphs/24-48/glyph_camera_24+.svg": [
		"5VZT",
		7984
	],
	"./glyphs/24-48/glyph_camera_circle_filled_24+.svg": [
		"g4EV",
		40286
	],
	"./glyphs/24-48/glyph_camera_rotate_24+.svg": [
		"Z0/4",
		87194
	],
	"./glyphs/24-48/glyph_card_24+.svg": [
		"QF/O",
		9471
	],
	"./glyphs/24-48/glyph_carousel_24+.svg": [
		"hX8S",
		97691
	],
	"./glyphs/24-48/glyph_carousel_2_24+.svg": [
		"2s4U",
		62340
	],
	"./glyphs/24-48/glyph_carousel_calls_24+.svg": [
		"uqKA",
		83833
	],
	"./glyphs/24-48/glyph_carousel_calls_play_24+.svg": [
		"gmKC",
		69510
	],
	"./glyphs/24-48/glyph_cat_24+.svg": [
		"1U0+",
		37991
	],
	"./glyphs/24-48/glyph_chat_background_24+.svg": [
		"kWVr",
		99362
	],
	"./glyphs/24-48/glyph_check_24+.svg": [
		"Di4p",
		76471
	],
	"./glyphs/24-48/glyph_check_circle_off_24+.svg": [
		"CN+C",
		53284
	],
	"./glyphs/24-48/glyph_check_circle_on_24+.svg": [
		"vOh6",
		23242
	],
	"./glyphs/24-48/glyph_check_circle_on_filled_24+.svg": [
		"KTLb",
		32501
	],
	"./glyphs/24-48/glyph_checkbox_24+.svg": [
		"J41Y",
		52438
	],
	"./glyphs/24-48/glyph_checkbox_off_24+.svg": [
		"dccd",
		81046
	],
	"./glyphs/24-48/glyph_checks_24+.svg": [
		"pw14",
		18782
	],
	"./glyphs/24-48/glyph_clear_24+.svg": [
		"IWXR",
		63696
	],
	"./glyphs/24-48/glyph_clips_24+.svg": [
		"6V1J",
		45334
	],
	"./glyphs/24-48/glyph_clock_24+.svg": [
		"e7Za",
		61665
	],
	"./glyphs/24-48/glyph_close_24+.svg": [
		"vxEO",
		51803
	],
	"./glyphs/24-48/glyph_close_circle_24+.svg": [
		"kfyB",
		55150
	],
	"./glyphs/24-48/glyph_close_circle_filled_24+.svg": [
		"wInw",
		35681
	],
	"./glyphs/24-48/glyph_collage_24+.svg": [
		"Noas",
		14368
	],
	"./glyphs/24-48/glyph_collage_selected_24+.svg": [
		"EqEk",
		22876
	],
	"./glyphs/24-48/glyph_comment_24+-1.svg": [
		"FcIs",
		90342
	],
	"./glyphs/24-48/glyph_comment_24+.svg": [
		"Sgo/",
		29352
	],
	"./glyphs/24-48/glyph_comment_off_24+.svg": [
		"CK1C",
		6754
	],
	"./glyphs/24-48/glyph_comment_translation_24+.svg": [
		"QpQs",
		81644
	],
	"./glyphs/24-48/glyph_competition_24+.svg": [
		"mim2",
		6070
	],
	"./glyphs/24-48/glyph_computer_24+.svg": [
		"A30+",
		82390
	],
	"./glyphs/24-48/glyph_computer_play_24+.svg": [
		"cuj4",
		19151
	],
	"./glyphs/24-48/glyph_copy_24+.svg": [
		"RG3b",
		61062
	],
	"./glyphs/24-48/glyph_crop_24+.svg": [
		"a12p",
		50091
	],
	"./glyphs/24-48/glyph_cut_24+.svg": [
		"WnZy",
		49659
	],
	"./glyphs/24-48/glyph_day_24+.svg": [
		"KhFL",
		13409
	],
	"./glyphs/24-48/glyph_delivery_24+.svg": [
		"ro/q",
		88053
	],
	"./glyphs/24-48/glyph_description_24+.svg": [
		"7bwX",
		30937
	],
	"./glyphs/24-48/glyph_developer_24+.svg": [
		"nKVv",
		12261
	],
	"./glyphs/24-48/glyph_diamond_24+.svg": [
		"BzeW",
		4451
	],
	"./glyphs/24-48/glyph_discover_24+.svg": [
		"E8xF",
		57852
	],
	"./glyphs/24-48/glyph_discussions_24+.svg": [
		"ff7W",
		4800
	],
	"./glyphs/24-48/glyph_discussions_off_24+.svg": [
		"SLit",
		16698
	],
	"./glyphs/24-48/glyph_dislike_24+.svg": [
		"PD6W",
		51274
	],
	"./glyphs/24-48/glyph_dislike_filled_24+.svg": [
		"66Mk",
		6133
	],
	"./glyphs/24-48/glyph_divider_24+.svg": [
		"5gsj",
		4108
	],
	"./glyphs/24-48/glyph_done_24+.svg": [
		"2hYe",
		17809
	],
	"./glyphs/24-48/glyph_dots_24+.svg": [
		"lDTO",
		48881
	],
	"./glyphs/24-48/glyph_down_24+.svg": [
		"oB5r",
		18833
	],
	"./glyphs/24-48/glyph_download_24+.svg": [
		"S4ax",
		26897
	],
	"./glyphs/24-48/glyph_download_off_24+.svg": [
		"m0t8",
		40167
	],
	"./glyphs/24-48/glyph_drag_24+.svg": [
		"C3eH",
		77987
	],
	"./glyphs/24-48/glyph_duel_star_24+.svg": [
		"N+DA",
		3590
	],
	"./glyphs/24-48/glyph_duel_star_filled_24+.svg": [
		"Zoro",
		83529
	],
	"./glyphs/24-48/glyph_edit_24+.svg": [
		"dnZE",
		79545
	],
	"./glyphs/24-48/glyph_education_24+.svg": [
		"YzT+",
		86941
	],
	"./glyphs/24-48/glyph_events_24+.svg": [
		"rL2/",
		58098
	],
	"./glyphs/24-48/glyph_explicit_24+.svg": [
		"sprI",
		49605
	],
	"./glyphs/24-48/glyph_explicit_filled_24+.svg": [
		"DMms",
		27720
	],
	"./glyphs/24-48/glyph_fast_time_24+.svg": [
		"tLU3",
		48393
	],
	"./glyphs/24-48/glyph_favourite_24+.svg": [
		"oJyB",
		41042
	],
	"./glyphs/24-48/glyph_favourite_filled_24+.svg": [
		"8Gq8",
		28717
	],
	"./glyphs/24-48/glyph_favourite_half_filled_24+.svg": [
		"y0rf",
		97189
	],
	"./glyphs/24-48/glyph_favourite_off_24+.svg": [
		"ATnf",
		140
	],
	"./glyphs/24-48/glyph_feed_24+.svg": [
		"asY0",
		31633
	],
	"./glyphs/24-48/glyph_feed_follow_24+.svg": [
		"yk5I",
		92031
	],
	"./glyphs/24-48/glyph_feed_follow_on_24+.svg": [
		"hzQT",
		92689
	],
	"./glyphs/24-48/glyph_feed_off_24+.svg": [
		"UPDV",
		77383
	],
	"./glyphs/24-48/glyph_file_24+.svg": [
		"czQd",
		89399
	],
	"./glyphs/24-48/glyph_file_selected_24+.svg": [
		"d0tg",
		92201
	],
	"./glyphs/24-48/glyph_filter_24+.svg": [
		"zIEI",
		26367
	],
	"./glyphs/24-48/glyph_fire_24+.svg": [
		"seBO",
		7953
	],
	"./glyphs/24-48/glyph_flag_24+.svg": [
		"UeH6",
		35559
	],
	"./glyphs/24-48/glyph_flash_24+.svg": [
		"R9Lw",
		10917
	],
	"./glyphs/24-48/glyph_flash_auto_24+.svg": [
		"ojM3",
		34509
	],
	"./glyphs/24-48/glyph_flash_off_24+.svg": [
		"KPDX",
		12459
	],
	"./glyphs/24-48/glyph_flashlight_24+.svg": [
		"eWCk",
		92559
	],
	"./glyphs/24-48/glyph_flip_24+.svg": [
		"xpN5",
		93820
	],
	"./glyphs/24-48/glyph_flower_24+.svg": [
		"gWDf",
		15544
	],
	"./glyphs/24-48/glyph_flower_chamomile_24+.svg": [
		"GWKk",
		96800
	],
	"./glyphs/24-48/glyph_flyer_24+.svg": [
		"ewok",
		63577
	],
	"./glyphs/24-48/glyph_follow_24+.svg": [
		"R3qh",
		84746
	],
	"./glyphs/24-48/glyph_food_24+.svg": [
		"VMW9",
		88301
	],
	"./glyphs/24-48/glyph_food_tag_fill_24+.svg": [
		"kjsm",
		53304
	],
	"./glyphs/24-48/glyph_food_tag_outline_24+.svg": [
		"6b91",
		68515
	],
	"./glyphs/24-48/glyph_forum_24+.svg": [
		"5Ih+",
		59968
	],
	"./glyphs/24-48/glyph_forward_24+.svg": [
		"ZABe",
		38940
	],
	"./glyphs/24-48/glyph_funnel_24+.svg": [
		"QomF",
		87365
	],
	"./glyphs/24-48/glyph_games_24+.svg": [
		"483b",
		96730
	],
	"./glyphs/24-48/glyph_geo_24+.svg": [
		"Kbn4",
		70152
	],
	"./glyphs/24-48/glyph_geo_layers_24+.svg": [
		"b4+6",
		19749
	],
	"./glyphs/24-48/glyph_gif_sticker_2_24+.svg": [
		"0mjf",
		55334
	],
	"./glyphs/24-48/glyph_gif_sticker_filled_24+.svg": [
		"9Ovy",
		22032
	],
	"./glyphs/24-48/glyph_gif_web_24+.svg": [
		"68y7",
		80510
	],
	"./glyphs/24-48/glyph_gift_24+.svg": [
		"xr/L",
		43719
	],
	"./glyphs/24-48/glyph_gift_heart_24+.svg": [
		"r0PP",
		38038
	],
	"./glyphs/24-48/glyph_gift_off_24+.svg": [
		"PQV9",
		77773
	],
	"./glyphs/24-48/glyph_gift_question_filled_24+.svg": [
		"5frw",
		14101
	],
	"./glyphs/24-48/glyph_glasses_24+.svg": [
		"1OWY",
		38967
	],
	"./glyphs/24-48/glyph_globe_24+.svg": [
		"iRKr",
		18396
	],
	"./glyphs/24-48/glyph_google_chromecast_24+.svg": [
		"16sE",
		52324
	],
	"./glyphs/24-48/glyph_grid_24+.svg": [
		"DYr/",
		5881
	],
	"./glyphs/24-48/glyph_grid_off_24+.svg": [
		"sea2",
		90639
	],
	"./glyphs/24-48/glyph_groupnotif_24+.svg": [
		"uSRs",
		46712
	],
	"./glyphs/24-48/glyph_guessing_24+.svg": [
		"joUn",
		31156
	],
	"./glyphs/24-48/glyph_guests_24+.svg": [
		"aR7g",
		73774
	],
	"./glyphs/24-48/glyph_hair_24+.svg": [
		"C0NO",
		64445
	],
	"./glyphs/24-48/glyph_hand_24+.svg": [
		"0ath",
		86894
	],
	"./glyphs/24-48/glyph_hand_cursor_24+.svg": [
		"ZA7e",
		89567
	],
	"./glyphs/24-48/glyph_handiwork_tag_fill_24+.svg": [
		"Ine9",
		81123
	],
	"./glyphs/24-48/glyph_handiwork_tag_outline_24+.svg": [
		"z/yV",
		17514
	],
	"./glyphs/24-48/glyph_hashtag_24+.svg": [
		"SHKC",
		56571
	],
	"./glyphs/24-48/glyph_hashtag_square_24+.svg": [
		"e59V",
		64243
	],
	"./glyphs/24-48/glyph_headphones_24+.svg": [
		"/aH9",
		15908
	],
	"./glyphs/24-48/glyph_heart_add_24+.svg": [
		"7QHB",
		7507
	],
	"./glyphs/24-48/glyph_heart_cross_24+.svg": [
		"3/b+",
		52486
	],
	"./glyphs/24-48/glyph_hearts_24+.svg": [
		"ay1L",
		8762
	],
	"./glyphs/24-48/glyph_help_circle_24+.svg": [
		"XE+W",
		52707
	],
	"./glyphs/24-48/glyph_help_circle_filled_24+.svg": [
		"zaC7",
		49154
	],
	"./glyphs/24-48/glyph_history_backward_24+.svg": [
		"6GCt",
		5165
	],
	"./glyphs/24-48/glyph_history_media_backward_24+.svg": [
		"ZVmC",
		62234
	],
	"./glyphs/24-48/glyph_hobbies_24+.svg": [
		"eGsj",
		43747
	],
	"./glyphs/24-48/glyph_home_24+.svg": [
		"g2/m",
		89924
	],
	"./glyphs/24-48/glyph_indeterminate_24+.svg": [
		"SgbO",
		54370
	],
	"./glyphs/24-48/glyph_info_circle_24+.svg": [
		"1NCE",
		7536
	],
	"./glyphs/24-48/glyph_info_circle_filled_24+.svg": [
		"YaBn",
		54455
	],
	"./glyphs/24-48/glyph_invisible_24+.svg": [
		"RnsN",
		67486
	],
	"./glyphs/24-48/glyph_invisible_off_24+.svg": [
		"8udV",
		9048
	],
	"./glyphs/24-48/glyph_keyboard_24+.svg": [
		"UIAW",
		85270
	],
	"./glyphs/24-48/glyph_klass_24+.svg": [
		"RLes",
		7231
	],
	"./glyphs/24-48/glyph_klass_filled_24+.svg": [
		"2LuM",
		31302
	],
	"./glyphs/24-48/glyph_klass_groups_24+.svg": [
		"Z4pV",
		52842
	],
	"./glyphs/24-48/glyph_klass_star_24+.svg": [
		"E0Qg",
		18978
	],
	"./glyphs/24-48/glyph_lamp_24+.svg": [
		"OXF1",
		5827
	],
	"./glyphs/24-48/glyph_like_24+.svg": [
		"awEQ",
		54572
	],
	"./glyphs/24-48/glyph_link_external_24+.svg": [
		"Uizi",
		23625
	],
	"./glyphs/24-48/glyph_lips_24+.svg": [
		"RRuf",
		88799
	],
	"./glyphs/24-48/glyph_list_24+.svg": [
		"k5OG",
		45437
	],
	"./glyphs/24-48/glyph_list_numbers_24+.svg": [
		"b32v",
		19286
	],
	"./glyphs/24-48/glyph_location_24+.svg": [
		"z1Kd",
		97048
	],
	"./glyphs/24-48/glyph_location_off_24+.svg": [
		"62zI",
		92658
	],
	"./glyphs/24-48/glyph_lock_24+.svg": [
		"LPXk",
		97208
	],
	"./glyphs/24-48/glyph_lock_circle_filled_24+.svg": [
		"lWYD",
		79286
	],
	"./glyphs/24-48/glyph_logout_24+.svg": [
		"8BR6",
		75527
	],
	"./glyphs/24-48/glyph_lottery_24+.svg": [
		"4nX9",
		10628
	],
	"./glyphs/24-48/glyph_loudspeaker_24+.svg": [
		"IzXA",
		70800
	],
	"./glyphs/24-48/glyph_magic_24+.svg": [
		"6f+B",
		23762
	],
	"./glyphs/24-48/glyph_marker_24+.svg": [
		"03Rs",
		38003
	],
	"./glyphs/24-48/glyph_marker_circle_24+.svg": [
		"iB3r",
		89510
	],
	"./glyphs/24-48/glyph_market_24+.svg": [
		"YrPM",
		65681
	],
	"./glyphs/24-48/glyph_market_clock_24+.svg": [
		"4aAN",
		69314
	],
	"./glyphs/24-48/glyph_mask_24+.svg": [
		"zu2+",
		93025
	],
	"./glyphs/24-48/glyph_masters_24+.svg": [
		"revu",
		70026
	],
	"./glyphs/24-48/glyph_maximize_24+.svg": [
		"1jXS",
		56659
	],
	"./glyphs/24-48/glyph_med_tag_fill_24+.svg": [
		"ifvC",
		48376
	],
	"./glyphs/24-48/glyph_med_tag_outline_24+.svg": [
		"E3IU",
		30883
	],
	"./glyphs/24-48/glyph_medal_24+.svg": [
		"Xo7z",
		73874
	],
	"./glyphs/24-48/glyph_mention_24+.svg": [
		"3Wa3",
		82989
	],
	"./glyphs/24-48/glyph_menu_24+.svg": [
		"Q4MX",
		79920
	],
	"./glyphs/24-48/glyph_message_24+.svg": [
		"SeTd",
		73398
	],
	"./glyphs/24-48/glyph_message_new_24+.svg": [
		"gwHe",
		69257
	],
	"./glyphs/24-48/glyph_message_off_24+.svg": [
		"nyyS",
		52176
	],
	"./glyphs/24-48/glyph_message_readed_24+.svg": [
		"zvVi",
		54110
	],
	"./glyphs/24-48/glyph_microphone_24+.svg": [
		"ZFAS",
		14277
	],
	"./glyphs/24-48/glyph_microphone_filled_24+.svg": [
		"4fhg",
		53160
	],
	"./glyphs/24-48/glyph_microphone_karaoke_24+.svg": [
		"83v4",
		75334
	],
	"./glyphs/24-48/glyph_microphone_off_24+.svg": [
		"uE+P",
		63691
	],
	"./glyphs/24-48/glyph_microphone_shadow_24+.svg": [
		"cwv7",
		6916
	],
	"./glyphs/24-48/glyph_minimize_24+.svg": [
		"pfNl",
		2533
	],
	"./glyphs/24-48/glyph_minus_24+.svg": [
		"8AxR",
		40171
	],
	"./glyphs/24-48/glyph_minzdrav_tag_fill_24+.svg": [
		"fzOY",
		1215
	],
	"./glyphs/24-48/glyph_minzdrav_tag_outline_24+.svg": [
		"d7Eg",
		37446
	],
	"./glyphs/24-48/glyph_mobile_24+.svg": [
		"isIZ",
		80279
	],
	"./glyphs/24-48/glyph_moment_24+.svg": [
		"V32W",
		56853
	],
	"./glyphs/24-48/glyph_more_24+.svg": [
		"O6Xp",
		65138
	],
	"./glyphs/24-48/glyph_more_circle_24+.svg": [
		"QvCV",
		3853
	],
	"./glyphs/24-48/glyph_more_vertical_24+.svg": [
		"V+N8",
		86967
	],
	"./glyphs/24-48/glyph_movie_24+.svg": [
		"Emh+",
		59491
	],
	"./glyphs/24-48/glyph_music_24+.svg": [
		"Ytuy",
		23914
	],
	"./glyphs/24-48/glyph_music_album_24+.svg": [
		"L69M",
		37366
	],
	"./glyphs/24-48/glyph_music_flow_24+.svg": [
		"eJkc",
		42793
	],
	"./glyphs/24-48/glyph_music_melody_24+.svg": [
		"rAKs",
		99837
	],
	"./glyphs/24-48/glyph_music_note_24+.svg": [
		"Pn0B",
		64781
	],
	"./glyphs/24-48/glyph_music_search_24+.svg": [
		"vRCO",
		85693
	],
	"./glyphs/24-48/glyph_my_location_24+.svg": [
		"ul0v",
		65571
	],
	"./glyphs/24-48/glyph_neon_pen_circle_24+.svg": [
		"t0Qt",
		35612
	],
	"./glyphs/24-48/glyph_new_24+.svg": [
		"pyJL",
		24917
	],
	"./glyphs/24-48/glyph_new_star_filled_24+.svg": [
		"yMlI",
		32007
	],
	"./glyphs/24-48/glyph_news_tag_fill_24+.svg": [
		"rMe3",
		95087
	],
	"./glyphs/24-48/glyph_news_tag_outline_24+.svg": [
		"qKhC",
		66422
	],
	"./glyphs/24-48/glyph_next_24+.svg": [
		"VMhH",
		64694
	],
	"./glyphs/24-48/glyph_next_filled_24+.svg": [
		"GXVv",
		88377
	],
	"./glyphs/24-48/glyph_next_secs_24+.svg": [
		"VBmx",
		91291
	],
	"./glyphs/24-48/glyph_night_24+.svg": [
		"Arg6",
		64285
	],
	"./glyphs/24-48/glyph_notes_24+.svg": [
		"wsiS",
		7812
	],
	"./glyphs/24-48/glyph_notifications_24+.svg": [
		"3jrS",
		42703
	],
	"./glyphs/24-48/glyph_notifications_off_24+.svg": [
		"YCKC",
		84533
	],
	"./glyphs/24-48/glyph_notifications_on_24+.svg": [
		"0w7j",
		2401
	],
	"./glyphs/24-48/glyph_ok_24+.svg": [
		"OcPk",
		44615
	],
	"./glyphs/24-48/glyph_ok_business_24+.svg": [
		"PDbd",
		16208
	],
	"./glyphs/24-48/glyph_ok_circle_24+.svg": [
		"kz1o",
		10234
	],
	"./glyphs/24-48/glyph_ok_live_24+.svg": [
		"9pt/",
		60992
	],
	"./glyphs/24-48/glyph_ok_star_24+.svg": [
		"JvEc",
		52266
	],
	"./glyphs/24-48/glyph_pause_24+.svg": [
		"TBQC",
		23861
	],
	"./glyphs/24-48/glyph_pause_circle_24+.svg": [
		"Jott",
		1204
	],
	"./glyphs/24-48/glyph_pen_24+.svg": [
		"8QDf",
		47706
	],
	"./glyphs/24-48/glyph_pen_2_24+.svg": [
		"c6+e",
		68373
	],
	"./glyphs/24-48/glyph_pen_circle_24+.svg": [
		"p2k3",
		29621
	],
	"./glyphs/24-48/glyph_percent_24+.svg": [
		"u6a6",
		45764
	],
	"./glyphs/24-48/glyph_petard_24+.svg": [
		"duLX",
		36607
	],
	"./glyphs/24-48/glyph_phone_24+.svg": [
		"Wp4E",
		20627
	],
	"./glyphs/24-48/glyph_phone_circle_24+.svg": [
		"uuFu",
		98310
	],
	"./glyphs/24-48/glyph_phone_circle_filled_24+.svg": [
		"q6c4",
		23273
	],
	"./glyphs/24-48/glyph_phone_circle_filled_off_24+.svg": [
		"BP6i",
		79519
	],
	"./glyphs/24-48/glyph_phone_circle_off_24+.svg": [
		"IMRj",
		51488
	],
	"./glyphs/24-48/glyph_phone_incoming_call_24+.svg": [
		"0wfJ",
		27041
	],
	"./glyphs/24-48/glyph_phone_missed_call_24+.svg": [
		"bS/B",
		57848
	],
	"./glyphs/24-48/glyph_phone_off_24+.svg": [
		"bnGj",
		19113
	],
	"./glyphs/24-48/glyph_phone_outgoing_call_24+.svg": [
		"y4dt",
		49143
	],
	"./glyphs/24-48/glyph_photo_24+.svg": [
		"K/Cq",
		72751
	],
	"./glyphs/24-48/glyph_photo_add_24+.svg": [
		"GE1u",
		64287
	],
	"./glyphs/24-48/glyph_photo_album_24+.svg": [
		"Gct+",
		86487
	],
	"./glyphs/24-48/glyph_photo_clock_24+.svg": [
		"BEmU",
		73068
	],
	"./glyphs/24-48/glyph_photo_cover_install_24+.svg": [
		"MTX8",
		1647
	],
	"./glyphs/24-48/glyph_photo_crop_24+.svg": [
		"ly9X",
		2556
	],
	"./glyphs/24-48/glyph_photo_gallery_mobile_24+.svg": [
		"Bydd",
		18017
	],
	"./glyphs/24-48/glyph_photo_live_24+.svg": [
		"nsjl",
		17960
	],
	"./glyphs/24-48/glyph_photo_live_off_24+.svg": [
		"7iVV",
		30018
	],
	"./glyphs/24-48/glyph_photo_moment_add_24+.svg": [
		"LJ/t",
		56886
	],
	"./glyphs/24-48/glyph_photo_moment_clock_24.svg": [
		"IXkw",
		11554
	],
	"./glyphs/24-48/glyph_photo_ok_24+.svg": [
		"7H0b",
		41572
	],
	"./glyphs/24-48/glyph_photo_web_24+.svg": [
		"ogrQ",
		48164
	],
	"./glyphs/24-48/glyph_picture_in_picture_24+.svg": [
		"uzgY",
		3138
	],
	"./glyphs/24-48/glyph_pin_24+.svg": [
		"nKqW",
		68686
	],
	"./glyphs/24-48/glyph_pin_off_24+.svg": [
		"CfUh",
		43016
	],
	"./glyphs/24-48/glyph_placeholder_24+.svg": [
		"aMIk",
		20468
	],
	"./glyphs/24-48/glyph_play_24+.svg": [
		"RpFi",
		45539
	],
	"./glyphs/24-48/glyph_play_circle_24+.svg": [
		"klL4",
		22422
	],
	"./glyphs/24-48/glyph_play_circle_filled_24+.svg": [
		"kScc",
		65657
	],
	"./glyphs/24-48/glyph_play_filled_24+.svg": [
		"w+6B",
		62178
	],
	"./glyphs/24-48/glyph_play_next_24+.svg": [
		"mHRp",
		24081
	],
	"./glyphs/24-48/glyph_play_small_filled_24+.svg": [
		"siAl",
		32986
	],
	"./glyphs/24-48/glyph_playlist_24+.svg": [
		"hyV6",
		93327
	],
	"./glyphs/24-48/glyph_playlist_add_24+.svg": [
		"u5wc",
		22527
	],
	"./glyphs/24-48/glyph_poll_24+-1.svg": [
		"kVQ4",
		67492
	],
	"./glyphs/24-48/glyph_poll_24+.svg": [
		"2Ays",
		27486
	],
	"./glyphs/24-48/glyph_pram_24+.svg": [
		"G45s",
		4769
	],
	"./glyphs/24-48/glyph_previous_24+.svg": [
		"1v0d",
		97546
	],
	"./glyphs/24-48/glyph_previous_filled_24+.svg": [
		"ciIM",
		16629
	],
	"./glyphs/24-48/glyph_previous_secs_24+.svg": [
		"VLut",
		66503
	],
	"./glyphs/24-48/glyph_promote_24+.svg": [
		"17sv",
		66595
	],
	"./glyphs/24-48/glyph_proportion_24+.svg": [
		"1rOi",
		13511
	],
	"./glyphs/24-48/glyph_qrcode_24+.svg": [
		"qCg2",
		20355
	],
	"./glyphs/24-48/glyph_question_24+.svg": [
		"61Lp",
		39841
	],
	"./glyphs/24-48/glyph_question_add_24+.svg": [
		"IdbZ",
		24109
	],
	"./glyphs/24-48/glyph_question_cross_24+.svg": [
		"xzQd",
		4308
	],
	"./glyphs/24-48/glyph_question_filled_24+.svg": [
		"1ozr",
		75340
	],
	"./glyphs/24-48/glyph_question_moments_24+.svg": [
		"sqao",
		23991
	],
	"./glyphs/24-48/glyph_quote_24+.svg": [
		"QPIa",
		31503
	],
	"./glyphs/24-48/glyph_radio_24+.svg": [
		"JVeG",
		74034
	],
	"./glyphs/24-48/glyph_rating_24+.svg": [
		"WgLk",
		48566
	],
	"./glyphs/24-48/glyph_readed_24+.svg": [
		"cv7W",
		97322
	],
	"./glyphs/24-48/glyph_refresh_24+.svg": [
		"kZR2",
		9802
	],
	"./glyphs/24-48/glyph_religion_tag_fill_24+.svg": [
		"A+6Z",
		10499
	],
	"./glyphs/24-48/glyph_religion_tag_outline_24+.svg": [
		"ehKa",
		40778
	],
	"./glyphs/24-48/glyph_repeat_1_24+.svg": [
		"NdAn",
		77759
	],
	"./glyphs/24-48/glyph_repeat_24+.svg": [
		"BWPl",
		13336
	],
	"./glyphs/24-48/glyph_reply_24+.svg": [
		"PH3p",
		24703
	],
	"./glyphs/24-48/glyph_reshare_24+.svg": [
		"6hdW",
		53427
	],
	"./glyphs/24-48/glyph_reshare_ok_24+.svg": [
		"+WtS",
		4192
	],
	"./glyphs/24-48/glyph_right_24+.svg": [
		"jPry",
		60081
	],
	"./glyphs/24-48/glyph_right_big_24+.svg": [
		"Jl4I",
		33266
	],
	"./glyphs/24-48/glyph_rings_24+.svg": [
		"yOu3",
		81582
	],
	"./glyphs/24-48/glyph_rose_flower_24+.svg": [
		"jyEL",
		44522
	],
	"./glyphs/24-48/glyph_rotate_photo_24+.svg": [
		"fZb4",
		36349
	],
	"./glyphs/24-48/glyph_rubl_circle_24+.svg": [
		"KgGW",
		91127
	],
	"./glyphs/24-48/glyph_rubl_circle_off_24+.svg": [
		"wyks",
		33149
	],
	"./glyphs/24-48/glyph_scan_24+.svg": [
		"A2cV",
		81950
	],
	"./glyphs/24-48/glyph_screen_sharing_off_24+.svg": [
		"9qS9",
		51394
	],
	"./glyphs/24-48/glyph_screen_sharing_on_24+.svg": [
		"jZT0",
		96192
	],
	"./glyphs/24-48/glyph_search_24+.svg": [
		"+OlB",
		66949
	],
	"./glyphs/24-48/glyph_search_catalog_24+.svg": [
		"LKbk",
		30309
	],
	"./glyphs/24-48/glyph_search_star_24+.svg": [
		"I9UI",
		75536
	],
	"./glyphs/24-48/glyph_search_web_24+.svg": [
		"9c/c",
		73246
	],
	"./glyphs/24-48/glyph_send_24+.svg": [
		"lb4l",
		92351
	],
	"./glyphs/24-48/glyph_send_filled_24+.svg": [
		"u7eZ",
		69926
	],
	"./glyphs/24-48/glyph_send_filled_off_24+.svg": [
		"Fh8k",
		82336
	],
	"./glyphs/24-48/glyph_send_off_24+.svg": [
		"vjp3",
		51301
	],
	"./glyphs/24-48/glyph_services_24+.svg": [
		"cDyS",
		40873
	],
	"./glyphs/24-48/glyph_settings_24+.svg": [
		"+AEo",
		95770
	],
	"./glyphs/24-48/glyph_share_24+.svg": [
		"Rx/g",
		27886
	],
	"./glyphs/24-48/glyph_shield_admin_24+.svg": [
		"IDUx",
		14090
	],
	"./glyphs/24-48/glyph_shield_moderator_24+.svg": [
		"GkQY",
		79998
	],
	"./glyphs/24-48/glyph_shield_moderator_off_24+.svg": [
		"+BnP",
		38712
	],
	"./glyphs/24-48/glyph_shield_moderator_super_24+.svg": [
		"fpNO",
		52110
	],
	"./glyphs/24-48/glyph_shield_safety_24+.svg": [
		"yiR+",
		52379
	],
	"./glyphs/24-48/glyph_shield_star_24+.svg": [
		"MB2N",
		8165
	],
	"./glyphs/24-48/glyph_shopping_cart_24+.svg": [
		"YJgN",
		3342
	],
	"./glyphs/24-48/glyph_shortcut_24+.svg": [
		"z/yy",
		53187
	],
	"./glyphs/24-48/glyph_shortcut_2_24+.svg": [
		"6PlI",
		10012
	],
	"./glyphs/24-48/glyph_shuffle_24+.svg": [
		"aaad",
		28944
	],
	"./glyphs/24-48/glyph_smile_24+.svg": [
		"aTSG",
		47271
	],
	"./glyphs/24-48/glyph_smile_sad_24+.svg": [
		"ZF4N",
		49446
	],
	"./glyphs/24-48/glyph_smile_square_24+.svg": [
		"UoVL",
		66127
	],
	"./glyphs/24-48/glyph_sort_24+.svg": [
		"XsnD",
		17805
	],
	"./glyphs/24-48/glyph_sound_24+.svg": [
		"F+6V",
		12798
	],
	"./glyphs/24-48/glyph_sound_bluetooth_24+.svg": [
		"dekv",
		14833
	],
	"./glyphs/24-48/glyph_sound_minimal_24+.svg": [
		"W1hm",
		89318
	],
	"./glyphs/24-48/glyph_sound_off_24+.svg": [
		"+wsC",
		61976
	],
	"./glyphs/24-48/glyph_sound_pad_24+.svg": [
		"Rdke",
		50956
	],
	"./glyphs/24-48/glyph_sparkle_24+.svg": [
		"6cDD",
		16565
	],
	"./glyphs/24-48/glyph_sparkles_24+.svg": [
		"qGe4",
		90804
	],
	"./glyphs/24-48/glyph_sport_24+.svg": [
		"Obfc",
		3717
	],
	"./glyphs/24-48/glyph_star_24+.svg": [
		"SRW8",
		12745
	],
	"./glyphs/24-48/glyph_star_congratulations_24+.svg": [
		"O9TI",
		13089
	],
	"./glyphs/24-48/glyph_statistics_24+.svg": [
		"tW80",
		63116
	],
	"./glyphs/24-48/glyph_store_24+.svg": [
		"oFHv",
		89720
	],
	"./glyphs/24-48/glyph_sun_smile_24+.svg": [
		"+g0S",
		73836
	],
	"./glyphs/24-48/glyph_symbols_24+.svg": [
		"PZwj",
		51804
	],
	"./glyphs/24-48/glyph_taxi_24+.svg": [
		"6Pom",
		9161
	],
	"./glyphs/24-48/glyph_text_24+.svg": [
		"DffK",
		87624
	],
	"./glyphs/24-48/glyph_text_bg_off_24+.svg": [
		"wEmk",
		88008
	],
	"./glyphs/24-48/glyph_text_bold_24+.svg": [
		"K4Pw",
		61406
	],
	"./glyphs/24-48/glyph_text_code_24+.svg": [
		"FC/M",
		72596
	],
	"./glyphs/24-48/glyph_text_cross_out_24+.svg": [
		"8zgD",
		1664
	],
	"./glyphs/24-48/glyph_text_header_24+.svg": [
		"BlTN",
		30160
	],
	"./glyphs/24-48/glyph_text_italic_24+.svg": [
		"S7ep",
		48371
	],
	"./glyphs/24-48/glyph_text_on_24+.svg": [
		"d4R6",
		69088
	],
	"./glyphs/24-48/glyph_text_on_field_24+.svg": [
		"CwNP",
		14677
	],
	"./glyphs/24-48/glyph_text_on_sparkle_24+.svg": [
		"IYYJ",
		38179
	],
	"./glyphs/24-48/glyph_text_subheader_24+.svg": [
		"SlxN",
		64384
	],
	"./glyphs/24-48/glyph_text_underline_24+.svg": [
		"Octt",
		6565
	],
	"./glyphs/24-48/glyph_topic_24+.svg": [
		"ibsL",
		85066
	],
	"./glyphs/24-48/glyph_transport_24+.svg": [
		"YjcL",
		33436
	],
	"./glyphs/24-48/glyph_trash_24+.svg": [
		"ZVpF",
		45873
	],
	"./glyphs/24-48/glyph_tv_show_24+.svg": [
		"inZ9",
		35481
	],
	"./glyphs/24-48/glyph_undo_24+.svg": [
		"+6oJ",
		65199
	],
	"./glyphs/24-48/glyph_unlock_24+.svg": [
		"SGU4",
		10381
	],
	"./glyphs/24-48/glyph_unreaded_24+.svg": [
		"uHbZ",
		82219
	],
	"./glyphs/24-48/glyph_up_24+.svg": [
		"pG9d",
		47730
	],
	"./glyphs/24-48/glyph_upload_24+.svg": [
		"Fmdt",
		52106
	],
	"./glyphs/24-48/glyph_url_24+.svg": [
		"ixKu",
		98040
	],
	"./glyphs/24-48/glyph_user_24+.svg": [
		"OBEc",
		93756
	],
	"./glyphs/24-48/glyph_user_add_24+.svg": [
		"OmtM",
		40208
	],
	"./glyphs/24-48/glyph_user_add_contact_24+.svg": [
		"UQoh",
		16657
	],
	"./glyphs/24-48/glyph_user_added_24+.svg": [
		"+St4",
		28759
	],
	"./glyphs/24-48/glyph_user_block_24+.svg": [
		"2LtK",
		24758
	],
	"./glyphs/24-48/glyph_user_contact_24+.svg": [
		"6pZC",
		93525
	],
	"./glyphs/24-48/glyph_user_hide_24+.svg": [
		"EI00",
		73095
	],
	"./glyphs/24-48/glyph_user_online_24+.svg": [
		"jwHm",
		8958
	],
	"./glyphs/24-48/glyph_user_phonebook_24+.svg": [
		"9A/q",
		57974
	],
	"./glyphs/24-48/glyph_user_playing_24+.svg": [
		"FNqo",
		83679
	],
	"./glyphs/24-48/glyph_user_request_24+.svg": [
		"oZLU",
		28198
	],
	"./glyphs/24-48/glyph_user_search_24+.svg": [
		"fDxA",
		99307
	],
	"./glyphs/24-48/glyph_user_share_24+.svg": [
		"Pvul",
		6140
	],
	"./glyphs/24-48/glyph_user_square_24+.svg": [
		"vxDd",
		8834
	],
	"./glyphs/24-48/glyph_user_star_24+.svg": [
		"xkFI",
		96051
	],
	"./glyphs/24-48/glyph_user_tag_24+.svg": [
		"bIrr",
		70501
	],
	"./glyphs/24-48/glyph_users_24+.svg": [
		"O1KK",
		93411
	],
	"./glyphs/24-48/glyph_users_3_24+.svg": [
		"fuD7",
		5397
	],
	"./glyphs/24-48/glyph_users_hide_24+.svg": [
		"hk//",
		90734
	],
	"./glyphs/24-48/glyph_uslugi_24+.svg": [
		"oLyI",
		22616
	],
	"./glyphs/24-48/glyph_uturn_right_square_24+.svg": [
		"9WTM",
		28938
	],
	"./glyphs/24-48/glyph_verticalvideo_24+.svg": [
		"Wap3",
		64128
	],
	"./glyphs/24-48/glyph_video_24+.svg": [
		"2EKO",
		50954
	],
	"./glyphs/24-48/glyph_video_animation_24+.svg": [
		"1qU2",
		16261
	],
	"./glyphs/24-48/glyph_video_blog_24+.svg": [
		"/dTI",
		46629
	],
	"./glyphs/24-48/glyph_video_catalog_24+.svg": [
		"7cTi",
		48546
	],
	"./glyphs/24-48/glyph_video_mini_24+.svg": [
		"gnUo",
		67224
	],
	"./glyphs/24-48/glyph_video_normal_24+.svg": [
		"YqXG",
		78160
	],
	"./glyphs/24-48/glyph_videocam_24+.svg": [
		"f8tq",
		3111
	],
	"./glyphs/24-48/glyph_videocam_incoming_call_24+.svg": [
		"JUVG",
		5661
	],
	"./glyphs/24-48/glyph_videocam_missed_call_24+.svg": [
		"wgvD",
		65972
	],
	"./glyphs/24-48/glyph_videocam_off_24+.svg": [
		"ZBKG",
		14541
	],
	"./glyphs/24-48/glyph_videocam_outgoing_call_24+.svg": [
		"ZQH2",
		53923
	],
	"./glyphs/24-48/glyph_videocam_recording_24+.svg": [
		"n5GO",
		19855
	],
	"./glyphs/24-48/glyph_videocam_translation_24+.svg": [
		"L1Pj",
		31675
	],
	"./glyphs/24-48/glyph_view_24+.svg": [
		"1Wd5",
		83314
	],
	"./glyphs/24-48/glyph_view_off_24+.svg": [
		"WrUJ",
		8556
	],
	"./glyphs/24-48/glyph_vip_24+.svg": [
		"4mlh",
		11498
	],
	"./glyphs/24-48/glyph_vk_24+.svg": [
		"+OX7",
		12800
	],
	"./glyphs/24-48/glyph_vk_square_24+.svg": [
		"sHsX",
		50118
	],
	"./glyphs/24-48/glyph_vk_square_filled_24+.svg": [
		"mMLF",
		70409
	],
	"./glyphs/24-48/glyph_wallet_24+.svg": [
		"Bb9Q",
		50322
	],
	"./glyphs/24-48/glyph_wallet_off_24+.svg": [
		"qyVM",
		74188
	],
	"./glyphs/24-48/glyph_warning_triangle_24+.svg": [
		"WLpN",
		41090
	],
	"./glyphs/24-48/glyph_web_24+.svg": [
		"K421",
		65909
	],
	"./glyphs/24-48/glyph_wifi_24+.svg": [
		"ivQ/",
		10250
	],
	"./glyphs/24-48/glyph_work_24+.svg": [
		"uRDW",
		53106
	],
	"./glyphs/24-48/glyph_zoom_24+.svg": [
		"Bkph",
		49888
	],
	"./glyphs/24-48/icо_gif_24+.svg": [
		"4S/y",
		35833
	],
	"./icos/16-20/ico_cry_colored_16_20.svg": [
		"A4Ph",
		41022
	],
	"./icos/16-20/ico_heart_colored_16_20.svg": [
		"pt0E",
		60102
	],
	"./icos/16-20/ico_klass_colored_16_20.svg": [
		"zg+i",
		35642
	],
	"./icos/16-20/ico_lol_colored_16_20.svg": [
		"otCc",
		71259
	],
	"./icos/16-20/ico_love_colored_16_20.svg": [
		"wXgO",
		97930
	],
	"./icos/16-20/ico_privateklass_colored_16_20.svg": [
		"sCMN",
		96837
	],
	"./icos/16-20/ico_rock_colored_16_20.svg": [
		"q99i",
		52781
	],
	"./icos/16-20/ico_sad_colored_16_20.svg": [
		"XeIQ",
		76318
	],
	"./icos/16-20/ico_scare_colored_16_20.svg": [
		"MtKD",
		49346
	],
	"./icos/16-20/ico_smile_colored_16_20.svg": [
		"Dwg1",
		33030
	],
	"./icos/16-20/ico_wow_colored_16_20.svg": [
		"qkgd",
		4175
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "SGVu";
module.exports = webpackAsyncContext;